export const SERVICE_AGENT = 'service-manager'

export const CONTAINER_MANAGER_AGENT = 'container-manager'
